import { render, staticRenderFns } from "./apiGuide.vue?vue&type=template&id=b48351fc&scoped=true"
import script from "./apiGuide.vue?vue&type=script&lang=js"
export * from "./apiGuide.vue?vue&type=script&lang=js"
import style0 from "./apiGuide.vue?vue&type=style&index=0&id=b48351fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48351fc",
  null
  
)

export default component.exports